import { strings } from "validations";
import * as yup from "yup";

export const addNewTagSchema = yup
  .object({
    title: yup.string().required(strings("").required),
    link: yup.string().required(strings("").required),
  })
  .required();

  export default addNewTagSchema